import React from 'react';
import { observer } from 'mobx-react-lite';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { FilterDropdown } from 'components/common/general/CollectionManagementPanel/FilterDropdown';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { PRODUCT_TEMPLATES_FILTERS } from '../../constants';

export const ProductLineFilterDropdown: React.FC = observer(() => {
  const {
    paginationDelegate: { filters, setFilterValue },
    availableProductLineIds,
  } = useRFQProductTemplatesStore();

  const productLineOptions = availableProductLineIds.map((pLineId) => ({
    value: pLineId,
    label: PRODUCT_LINES_CONTENT_MAP[pLineId].label,
  }));

  const selectedLabel = productLineOptions.find((opt) => opt.value === filters.productLineId)?.label || '';

  const onApplyFilter = (value: string | null): void => {
    if (value) {
      setFilterValue('productLineId', value as ProductLineId);
    }
  };

  return (
    <FilterDropdown
      filterName="Product Line"
      $minWidth="25rem"
      optionsWidth="25rem"
      selectedFilterLabel={selectedLabel}
      filtersList={productLineOptions}
      applyFilter={onApplyFilter}
      data-test-id={PRODUCT_TEMPLATES_FILTERS.PRODUCT_LINE_FILTER_DROPDOWN_TEST_ID}
    />
  );
});
